import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useStatusDocumento = () => {
  const [statusDocumento, setStatusDocumento] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchStatusDocumento = async () => {
      try {
        const response = await httpClient.get(
          `/api/documentossisdaf/enumStatusDocumento`,
        );

        const options = response.data.map(
          (documento: { value: number; label: string }) => ({
            value: documento.value.toString(),
            label: documento.label,
          }),
        );
        setStatusDocumento(options);
      } catch (error) {
        console.error('Erro ao buscar Status de Documentos', error);
      }
    };

    fetchStatusDocumento();
  }, []);

  return statusDocumento;
};
